import { createContext, useContext } from 'react';

/** Switches to News → All Clusters and pre-selects this notebook in Save to notebook. */
export type OpenRadarAttachFn = (notebookId: string) => void;

export const OpenRadarAttachContext = createContext<OpenRadarAttachFn>(() => {});

export function useOpenRadarAttach(): OpenRadarAttachFn {
  return useContext(OpenRadarAttachContext);
}
